import { Link } from "react-router-dom";

export default function SafetySection() {
  return (
    <section id="safety" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            {/* Left: Image */}
            <div className="flex-1 w-full">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3] max-w-md mx-auto lg:max-w-none">
                <img
                  src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20trust%20and%20security%20concept%20illustration%20with%20subtle%20translucent%20shield%20form%20in%20sage%20green%20tones%2C%20warm%20cream%20background%20with%20gentle%20gradient%2C%20abstract%20data%20protection%20visualization%2C%20calm%20reassuring%20aesthetic%2C%20modern%20SaaS%20inspired%20clean%20design%20language%2C%20professional%20yet%20approachable%20visual%20style%2C%20Western%20corporate%20trust%20imagery%2C%20clean%20composition%20with%20ample%20breathing%20space%2C%20sophisticated%20simplicity%2C%20high%20key%20soft%20photography%20look&width=800&height=600&seq=safety-vb-v2-2026z&orientation=landscape"
                  alt="Vigorbuy Spreadsheet safety and transparency information"
                  title="Is Vigorbuy Spreadsheet Safe - Safety Guide"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Right: Content */}
            <div className="flex-1 text-left">
              <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100 px-3 py-1 rounded-full mb-4 tracking-wide">
                (Safety & Transparency)
              </span>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold leading-tight mb-6">
                Is Vigorbuy Spreadsheet{" "}
                <span className="text-accent-600">Safe</span>?
                <br />
                <span className="text-foreground-400 font-light">
                  Full Security Overview
                </span>
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                <p>
                  Safety and transparency are core values of the Vigorbuy
                  Spreadsheet ecosystem. This website provides educational
                  information only and does not collect sensitive personal data
                  from visitors. The spreadsheet resource itself is a curated,
                  informational tool designed to help users make informed
                  decisions about fashion product discovery.
                </p>
                <p>
                  We encourage all users to verify information independently
                  before making purchasing decisions, review external websites
                  carefully, and always exercise personal judgment. The Vigorbuy
                  Spreadsheet does not process payments, store financial data,
                  or require account creation — making it inherently low-risk
                  for all users.
                </p>
                <p>
                  Our content undergoes regular review to ensure accuracy, and
                  we maintain strict editorial standards that prioritize
                  honesty, clarity, and user empowerment. When you use the
                  Vigorbuy Spreadsheet, you are leveraging a transparent tool
                  built with consumer trust as its foundation.
                </p>
              </div>
              <div className="flex flex-wrap gap-3 mt-8">
                <Link
                  to="/vigorbuy-spreadsheet-guide"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  Read Safety Guide
                  <i className="ri-shield-check-line text-sm"></i>
                </Link>
                <a
                  href="#faq"
                  className="inline-flex items-center gap-2 px-6 py-3 border-2 border-background-300 text-foreground-700 text-sm font-medium rounded-full hover:border-accent-300 hover:text-accent-600 transition-all duration-200 whitespace-nowrap"
                >
                  View FAQ
                  <i className="ri-arrow-down-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}